// extracted by mini-css-extract-plugin
export default {"container":"time_container__1EIJ8"};